import { useState } from 'react';
import styled from 'styled-components';
import { Zone } from '~/data/types';

interface Props {
  src: string;
  zones: Zone[];
  onZoneClick: (zone: Zone) => void;
  width: number;
  height: number;
  onZoneHover: (zone: Zone | undefined) => void;
}

const ImageMappeurFixe = ({
  src,
  zones,
  onZoneClick,
  width,
  height,
  onZoneHover,
}: Props) => {
  const [originalWidth, setOriginalWidth] = useState<number>(1);
  const [originalHeight, setOriginalHeight] = useState<number>(1);
  const [sHeight, setSHeight] = useState<number>(0);
  const [sWidth, setSWidth] = useState<number>(0);

  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setOriginalHeight(e.currentTarget.naturalHeight);
    setOriginalWidth(e.currentTarget.naturalWidth);

    const image = window.document.querySelector('#image-bg');
    if (image) {
      setSHeight(
        image.clientHeight > image.clientWidth
          ? image.clientWidth
          : image.clientHeight
      );
      setSWidth(
        image.clientWidth > image.clientHeight
          ? image.clientHeight
          : image.clientWidth
      );
    }
  };

  const recalculateCoords = (coords: number[]): string => {
    // une béquille pour regarder plus tard pourquoi observer donne 1 comme taille TODO
    const image = window.document.querySelector('#image-bg');

    if (image && height === 1 && width === 1) {
      const _height = height === 1 ? image.clientHeight : height;
      const _width = width === 1 ? image.clientWidth : width;

      let _h = _height;
      let _w = _width;
      if (_h === 0 || _w === 0) {
        if (_h === 0 && _w !== 0) {
          _h = _w;
        }
        if (_w === 0 && _h !== 0) {
          _w = _h;
        }
      } else {
        _h = _height > _width ? _width : _height;
        _w = _width > _height ? _height : _width;
      }

      const widthScale = _h / originalWidth;
      const heightScale = _w / originalHeight;

      const scaledCoords = coords.map((coord, index) =>
        index % 2 === 0 ? coord * widthScale : coord * heightScale
      );

      return scaledCoords.join(',');
    }
    // encore une bequille TODO
    if (image && (height === 0 || width === 0)) {
      if (image.clientHeight !== 0 && image.clientWidth !== 0) {
        const widthScale = image.clientWidth / originalWidth;
        const heightScale = image.clientHeight / originalHeight;

        const scaledCoords = coords.map((coord, index) =>
          index % 2 === 0 ? coord * widthScale : coord * heightScale
        );

        return scaledCoords.join(',');
      }
    }
    const _h = height > width ? width : height;
    const _w = width > height ? height : width;

    const widthScale = _w / originalWidth;
    const heightScale = _h / originalHeight;

    const scaledCoords = coords.map((coord, index) =>
      index % 2 === 0 ? coord * widthScale : coord * heightScale
    );

    return scaledCoords.join(',');
  };

  return (
    <ContainerMapper $sHeight={sHeight} $sWidth={sWidth}>
      <SImage
        $sHeight={sHeight}
        $sWidth={sWidth}
        alt="Map"
        id="image-bg"
        src={src}
        useMap="#primary"
        onLoad={(e) => handleImageLoad(e)}
        style={{ position: 'absolute', top: 0, left: 0, opacity: 0 }}
      />
      <SMap name="primary">
        {zones.map((zone, index) => (
          <area
            onMouseEnter={() => onZoneHover(zone)}
            onMouseLeave={() => onZoneHover(undefined)}
            key={index}
            shape="poly"
            coords={recalculateCoords(zone.coords)}
            href="#"
            alt=""
            onClick={(e) => {
              e.preventDefault();
              onZoneClick(zone);
            }}
          />
        ))}
      </SMap>
    </ContainerMapper>
  );
};

export default ImageMappeurFixe;

const ContainerMapper = styled.div<{ $sHeight?: number; $sWidth?: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${({ $sWidth }) => ($sWidth ? `${$sWidth}px` : '100%')};
  height: ${({ $sHeight }) => ($sHeight ? `${$sHeight}px` : '100%')};
  transform: translate(-50%, -50%);
  z-index: 100;
`;

const SImage = styled.img<{ $sHeight?: number; $sWidth?: number }>`
  width: ${({ $sWidth }) => ($sWidth ? `${$sWidth}px` : '100%')};
  height: ${({ $sHeight }) => ($sHeight ? `${$sHeight}px` : '100%')};
  object-fit: contain;
  pointer-events: auto;
`;

const SMap = styled.map`
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: auto;

  &&&& {
    z-index: 200;
    area {
      cursor: pointer;
      position: relative;
      z-index: 300;
      pointer-events: auto;
    }
  }
`;
